import { Component, OnInit, OnDestroy, Optional } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MasterreportingToolViewComponent } from 'src/app/shared/components/masterreporting-tool-view/masterreporting-tool-view.component';
import { DashboardService } from 'src/app/shared/service/dashboard/dashboard.service';
import { PortRequestFormServiceService } from 'src/app/shared/service/port-request-FormService/port-request-form.service.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

interface ReportItem {
  label: string;
  from_date: string;
  to_date: string;
  report_count: number;
  from_port?: string;   // ✅ ADD THIS
  to_port?: string;
  port?: string;
  total_hours: number;
  steaming_hours: number;
  voyage_number: string;
  cargo_quantity: number;
  operation?: string;

  // 🔹 NEW FIELDS FOR TRANSIT / PORT
  incinerator_consumption?: number;
  power_pack_consumption?: number;

  consumption?: {
    HSFO?: number;
    MGO?: number;
    ULSFO?: number;
    VLSFO?: number;
    LNG?: number;
    AE?: number;
    ME?: number;
    Boiler?: number;
    Others?: number;
    gasOilPowerPack?: number;
    incineratorGasOil?: number;
    inertingGasOil?: number;
  };

  distance?: {
    travelled?: number;
    remaining?: number;
  };

  rob?: {
    new?: {
      HSFO?: number;
      MGO?: number;
      ULSFO?: number;
      VLSFO?: number;
      LNG?: number;
    };
    old?: {
      HSFO?: number;
      MGO?: number;
      ULSFO?: number;
      VLSFO?: number;
      LNG?: number;
    };
  };

  weather?: {
    swellHeight?: string;
    seaHeight?: string;
    trueWindKnots?: string;
    windDescription?: string;
    airTemperature?: string;
  };

  expanded?: boolean;
  loadingDetails?: boolean;
  detailReports?: any[];
  _csvDownloading?: boolean;
  _csvProgress?: number;
  _csvProgressInterval?: any;
}

interface VoyageReportDetail {
  json_id: number;
  eventsList: string;
  report_timestamp: string;
  total_consumption: number;
  me_consumption: number;
  ae_consumption: number;
  blr_consumption: number;
  steamingDistanceGps: string;
  steamingHoursReport: string;
  verified: boolean;
  force_submission: boolean;
  voyageNumber: string;
  hsfo_rob?: number;
  lsfo_rob?: number;
  go_rob?: number;
}

type FuelType = 'VLSFO' | 'MGO' | 'HSFO' | 'ULSFO' | 'LNG';

@Component({
  selector: 'app-previous-vessel-summary',
  templateUrl: './previous-vessel-summary.component.html',
  styleUrls: ['./previous-vessel-summary.component.scss'],
})
export class PreviousVesselSummaryComponent implements OnInit, OnDestroy {
  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private portRequestFormService: PortRequestFormServiceService,
    private router: Router,
    private sharedDataService: DashboardService,
    private toastr: ToastrService,
    @Optional() private requestFormService?: RequestFormService
  ) { }

  // 🔹 Reactive Form
  filterForm!: FormGroup;
  isDark = true;
  // 🔹 Loader & Clock
  isLoading = true;
  utcTime = '';
  private clockInterval: any;

  // 🔹 Last 7 Days Control
  currentWeekOffset: number = 0;
  currentWeekStart!: Date;
  currentWeekEnd!: Date;

  seaReports: ReportItem[] = [];
  portReports: ReportItem[] = [];
  reportDetailsMap: { [key: number]: VoyageReportDetail[] } = {};
  loadingDetailsId: number | null = null;

  vessels: string[] = ['MT Horizon', 'MV Atlantic', 'SS Neptune'];
  voyages: string[] = ['V001', 'V002', 'V003'];
  vesselList: any[] = [];
  selectedSeaReport: any;
  selectedPortReport: any;
  voyageList: any[] = [];

  // 🔹 UI Data
  vesselDots = Array.from({ length: 12 });
  dateRange = 'Jan 2, 2026 – Jan 31, 2026';
  weather = '🌤 28°C | Wind 12kn';
  reportStatusOptions = [
    { label: 'All', value: 'all' },
    { label: 'Verified Report', value: 'verified' },
    { label: 'Non-Verified Report', value: 'non_verified' },
    { label: 'Force Verified Report', value: 'force_verified' },
  ];
  seaAccordionOpen = false;
  portAccordionOpen = false;

  selectedReportStatus: string = 'all';
  selected: boolean = false;
  // 🔹 Summary Cards
  summaryCards = [
    { label: 'Cargo onboard', value: '13,258 mt' },
    { label: 'Consumption VLSFO', value: '24.9 mt' },
    { label: 'Consumption MGO', value: '0 mt' },
    { label: 'ROB VLSFO', value: '1094.553 mt' },
    { label: 'ROB MGO', value: '296 mt' },
    { label: 'Weather', value: '28°C' },
  ];
  allReports: ReportItem[] = [];
  fuelTypes: FuelType[] = ['VLSFO', 'MGO', 'HSFO', 'ULSFO', 'LNG'];
  isSubmitting: boolean = false;
  ngOnInit(): void {
    this.filterForm = this.fb.group({
      vesselName: [''],
      fromDate: [''],
      toDate: [''],
      reportType: ['all'],
      voyagePhase: ['both'],
    });

    this.updateWeekRange();

    this.isDark = this.requestFormService?.isDarkMode() ?? (localStorage.getItem('darkModePreference') !== 'false');
    if (this.requestFormService) {
      this.requestFormService.themeChanged.subscribe((dark: boolean) => {
        this.isDark = dark;
      });
    }

    this.loadVessels();

    // Vessel Change Listener
    // this.filterForm.get('vesselName')?.valueChanges.subscribe((imo: string) => {
    //   this.filterForm.patchValue({ voyageNumber: '' });
    //   this.loadVoyages(imo);
    // });

    setTimeout(() => {
      this.isLoading = false;
    }, 1000);

    this.updateClock();
    this.clockInterval = setInterval(() => this.updateClock(), 1000);
  }

  ngOnDestroy(): void {
    clearInterval(this.clockInterval);
  }
  loadVessels(): void {
    this.portRequestFormService.getVessels().subscribe({
      next: (res: any) => {
        if (res?.success) {
          this.vesselList = res.vessels || [];
        }
      },
      error: (err) => {
        console.error('Vessel Load Error:', err);
      },
    });
  }

  loadVoyages(imo: string): void {
    if (!imo) {
      this.voyageList = [];
      return;
    }

    this.portRequestFormService.getVoyageList(imo).subscribe({
      next: (res: any) => {
        if (res?.success) {
          this.voyageList = res.data || [];
        } else {
          this.voyageList = [];
        }
      },
      error: (err) => {
        console.error('Voyage Load Error:', err);
        this.voyageList = [];
      },
    });
  }
  onStatusChange(item: any, type: string, event: any): void {
    const isChecked = event.target.checked;

    if (type === 'verified') {
      item.verified = isChecked;
    }

    if (type === 'nonVerified') {
      item.nonVerified = isChecked;
    }

    if (type === 'forceVerified') {
      item.forceVerified = isChecked;
    }

    console.log('Updated Item:', item);
  }
  updateWeekRange(): void {
    const today = new Date();

    // Start from last 7 days
    const start = new Date(today);
    start.setDate(today.getDate() - 6 + this.currentWeekOffset * 7);

    const end = new Date(start);
    end.setDate(start.getDate() + 6);

    this.currentWeekStart = start;
    this.currentWeekEnd = end;

    this.dateRange = start.toDateString() + ' - ' + end.toDateString();
  }

  nextWeek(): void {
    this.currentWeekOffset++;
    this.updateWeekRange();
  }

  previousWeek(): void {
    if (this.currentWeekOffset > 0) {
      this.currentWeekOffset--;
      this.updateWeekRange();
    }
  }

  changeReportStatus(status: string): void {
    this.selectedReportStatus = status;

    console.log('Selected Report Status:', status);

    // 👉 Yaha filter laga sakti ho timeline pe
    // Or API ko dubara hit kar sakti ho
  }

  // 🔹 Clock Update
  updateClock(): void {
    const now = new Date();
    this.utcTime = now.toUTCString().split(' ')[4] + ' UTC';
  }

  toggleItem(item: any) {
    item.expanded = !item.expanded;

    if (item.expanded && !item.detailReports) {
      item.loadingDetails = true;

      const formattedFrom = this.formatDateForApi(item.from_date);
      const formattedTo = this.formatDateForApi(item.to_date);

      this.portRequestFormService
        .getReportsList(
          this.filterForm.get('vesselName')?.value,
          formattedFrom,
          formattedTo,
          '1',
          item.label === 'Sea Passage' ? 'sea' : 'port',
        )
        .subscribe((res) => {
          item.detailReports = res?.data || res;
          item.loadingDetails = false;
        });
    }
  }
  // editReport(detail: any, event: Event): void {
  //   event.stopPropagation();
  //   const imo = this.filterForm.get('vesselName')?.value;

  //   if (!imo || !detail?.json_id) {
  //     console.warn('IMO or Report ID missing');
  //     return;
  //   }

  //   this.router.navigate(['/pc-newForm'], {
  //     queryParams: {
  //       imo: imo,
  //       json_report_id: detail.json_id,
  //     },
  //   });
  // }
  editReport(detail: any, event: Event): void {
    event.stopPropagation();

    const imo = this.filterForm.get('vesselName')?.value;

    if (!imo) {
      console.warn('Vessel IMO not selected');
      return;
    }

    if (!detail?.json_id) {
      console.warn('Report ID missing');
      return;
    }

    detail.isViewing = true;
    const currentScrollY = window.scrollY;

    this.portRequestFormService
      .getPendingReportByIMO(imo, detail.json_id)
      .subscribe({
        next: (response) => {
          detail.isViewing = false;

          const dialogRef = this.dialog.open(MasterreportingToolViewComponent, {
            width: '1300px',
            maxHeight: '90vh',
            panelClass: 'report-view-dialog',
            autoFocus: false,
            restoreFocus: false,
            data: {
              ...response,
              isDark: this.isDark,
            },
          });

          // Ensure window scroll position is strictly preserved
          window.scrollTo({ top: currentScrollY, behavior: 'instant' as ScrollBehavior });
        },
        error: (err) => {
          detail.isViewing = false;
          console.error('Error loading report:', err);
        },
      });
  }

  formatDateForApi(date: string) {
    const d = new Date(date);
    return d.toISOString().split('T')[0];
  }
  openReport(detail: any): void {
    alert('Report ID: ' + detail.json_id);
  }

  // 🔹 Apply Filters
  applyFilters(): void {
    const formValues = this.filterForm.value;

    console.log('Applied Filters:', formValues);

    // 👉 Yaha API call laga sakti ho
    // this.service.getFilteredData(formValues).subscribe(...)
  }

  // 🔹 Clear Filters
  clearFilters(): void {
    this.filterForm.reset({
      picAnalyst: '',
      vesselName: '',
      voyageNumber: '',
      reportType: 'all',
    });
  }

  isDarkMode(): boolean {
    return this.isDark;
  }
  // Apply Filter
  filterClick(): void {
    this.applyFilters();
  }

  // Clear Filter
  clearClick(): void {
    this.clearFilters();
  }

  viewClick(): void {
    this.isSubmitting = true;
    const imo = this.filterForm.get('vesselName')?.value;
    const fromDate = this.filterForm.get('fromDate')?.value;
    const toDate = this.filterForm.get('toDate')?.value;
    const reportType = this.filterForm.get('reportType')?.value;

    if (!imo) {
      this.isSubmitting = false;
      console.warn('Select Vessel first');
      return;
    }

    this.portRequestFormService
      .getVoyageReportsByDate(imo, fromDate, toDate, reportType)
      .subscribe({
        next: (res: any) => {
          this.isSubmitting = false;
          const reports = res?.data || res;

          this.allReports = [];

          if (reports && reports.length) {
            reports.forEach((item: any) => {
              this.allReports.push({
                ...item,
                label: item.label === 'Port Passage' ? 'Port Stay' : item.label,
                expanded: false,
              });
              // this.allReports.push({
              //   ...item,
              //   expanded: false,
              // });
            });
          }

          console.log('All Reports:', this.allReports);
        },

        error: (err: any) => {
          this.isSubmitting = false;
          console.error('Date Filter Error:', err);
        },
      });
  }

  togglePortSection() {
    this.portAccordionOpen = !this.portAccordionOpen;
  }

  selectSeaReport(index: string): void {
    const i = Number(index);
    this.selectedSeaReport = this.seaReports[i];
  }

  selectPortReport(index: string): void {
    const i = Number(index);
    this.selectedPortReport = this.portReports[i];
  }

  downloadAllReports(item: any, event: Event) {
    event.stopPropagation();

    const imo = this.filterForm.get('vesselName')?.value;

    if (!imo) {
      console.warn('Vessel not selected');
      return;
    }

    const payload = {
      imo: imo,
      start_datetime: this.formatDateTime(item.from_date),
      end_datetime: this.formatDateTime(item.to_date, true)
    };

    console.log('Download Payload:', payload);


    const apiCall = item.label == 'Sea Passage'
      ? this.sharedDataService.downloadMasterReport(payload)
      : this.portRequestFormService.downloadMasterReportPc(payload);

    apiCall.subscribe({
      next: (response: Blob) => {

        const blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.download = `${item.label}_${item.voyage_number}.xlsx`;

        link.click();

        window.URL.revokeObjectURL(url);
        this.toastr.success('Report downloaded successfully');
      },
      error: (err) => {
        console.error('Download Failed:', err);
      }
    });
  }
  formatDateTime(date: string, isEnd: boolean = false): string {
    const d = new Date(date);

    if (isEnd) {
      d.setUTCHours(23, 59, 59, 999);
    } else {
      d.setUTCHours(0, 0, 0, 0);
    }

    return d.toISOString();
  }
  
  /**
   * Downloads the global Sea Report based on the top filters.
   */
  downloadClick(): void {
    const imo = this.filterForm.get('vesselName')?.value;
    if (!imo) {
      this.toastr.warning('Please select a vessel first.');
      return;
    }

    let fromDate = this.filterForm.get('fromDate')?.value;
    let toDate = this.filterForm.get('toDate')?.value;
    
    if (!fromDate || !toDate) {
      this.toastr.warning('Please select both From Date and To Date for download.');
      return;
    }
    
    // Format to YYYY-MM-DDTHH:MM
    const start = fromDate + 'T00:00';
    const end = toDate + 'T23:59';
    const phase = this.filterForm.get('voyagePhase')?.value;
    
    this.toastr.info('Generating global CSV, this might take a minute...');
    
    this.sharedDataService.downloadSeaReportCsv(imo, start, end, phase).subscribe({
      next: (blob: Blob) => {
        const url  = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href  = url;
        link.download = `Global_Sea_Report_${imo}.csv`;
        link.click();
        window.URL.revokeObjectURL(url);
        this.toastr.success('Download completed successfully.');
      },
      error: (err: any) => {
        console.error('Global CSV Download Error:', err);
        this.toastr.error('Failed to download CSV.');
      }
    });
  }
  
  /**
   * Downloads the sea performance CSV report for a Sea Passage card.
   * Uses the item's from_date / to_date as the API start/end query params.
   * The API itself already filters only sea-passage rows and cuts off
   * non-at-sea periods, so no extra filtering is needed on the frontend.
   */
  downloadSeaReportCsv(item: any, event: Event): void {
    event.stopPropagation();

    const imo = this.filterForm.get('vesselName')?.value;
    if (!imo) {
      this.toastr.warning('Please select a vessel first.');
      return;
    }

    if (!item.from_date || !item.to_date) {
      this.toastr.warning('Date range not available for this passage.');
      return;
    }

    // Format: YYYY-MM-DDTHH:MM (UTC, start of day for from, end of day for to)
    const fmt = (dateStr: string, isEnd: boolean): string => {
      const d = new Date(dateStr);
      if (isNaN(d.getTime())) return dateStr.split('T')[0] + (isEnd ? 'T23:59' : 'T00:00');
      const pad = (n: number) => String(n).padStart(2, '0');
      const yyyy = d.getUTCFullYear();
      const mm   = pad(d.getUTCMonth() + 1);
      const dd   = pad(d.getUTCDate());
      const hh   = isEnd ? '23' : pad(d.getUTCHours());
      const min  = isEnd ? '59' : pad(d.getUTCMinutes());
      return `${yyyy}-${mm}-${dd}T${hh}:${min}`;
    };

    const start = fmt(item.from_date, false);
    const end   = fmt(item.to_date, true);

    item._csvDownloading = true;
    item._csvProgress = 0;

    // Fake progress interval: the backend takes ~30-40s to generate the CSV.
    // We increment by ~1-3% every 1000ms.
    item._csvProgressInterval = setInterval(() => {
      if (item._csvProgress !== undefined && item._csvProgress < 90) {
        item._csvProgress += Math.floor(Math.random() * 3) + 1;
        if (item._csvProgress > 90) item._csvProgress = 90;
      }
    }, 1000);

    this.sharedDataService.downloadSeaReportCsv(imo, start, end).subscribe({
      next: (blob: Blob) => {
        clearInterval(item._csvProgressInterval);
        item._csvProgress = 100;
        setTimeout(() => {
          item._csvDownloading = false;
        }, 500);

        const url  = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href  = url;
        // Build a sensible filename: <voyageNumber>_sea_report.csv
        const voyNum = item.voyage_number ? `_${item.voyage_number}` : '';
        link.download = `sea_report${voyNum}_${start.split('T')[0]}_${end.split('T')[0]}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.toastr.success('Sea Report CSV downloaded successfully');
      },
      error: (err: any) => {
        clearInterval(item._csvProgressInterval);
        item._csvProgress = 0;
        item._csvDownloading = false;
        console.error('Sea CSV Download Failed:', err);
        this.toastr.error('Failed to download Sea Report CSV. Please try again.');
      }
    });
  }

  downloadSingleReport(detail: any, event: Event, type: string) {
    event.stopPropagation();

    const imo = this.filterForm.get('vesselName')?.value;

    if (!imo) {
      console.warn('Vessel not selected');
      return;
    }

    if (!detail?.report_timestamp) {
      console.warn('Report timestamp missing');
      return;
    }

    const payload = {
      imo: imo,
      start_datetime: detail.report_timestamp,
      end_datetime: detail.report_timestamp
    };


    const apiCall = type === 'Sea Passage'
      ? this.sharedDataService.downloadMasterReport(payload)
      : this.portRequestFormService.downloadMasterReportPc(payload);

    apiCall.subscribe({
      next: (response: Blob) => {

        const blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.download = `Report_${detail.json_id}.xlsx`;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(url);
        this.toastr.success('Report downloaded successfully');
      },
      error: (err) => {
        console.error('Single Report Download Failed:', err);
      }
    });
  }

}
